import React from 'react';
import { connect } from 'react-redux';
import { findMatch } from '@/utils/resultsHelper';
import DictionaryFieldRow from '../components/DictionaryFieldRow';
import { resolveCatalogueTemplate } from '../../catalogue/helper';

const DictionaryFieldTableRows = ({
  category,
  code,
  dictionaryUUID,
  fields,
  canEdit,
  allowPmnTransfer,
  template,
}) => (
  fields.map((field, index) => (
    <DictionaryFieldRow
      key={`dictionary_table_row_${code}_${dictionaryUUID}_${field.uuid}`}
      category={category}
      code={code}
      fieldUUID={field.uuid}
      fieldName={field.name}
      dictionaryUUID={dictionaryUUID}
      canEdit={canEdit}
      upward={index > 4}
      allowPmnTransfer={allowPmnTransfer}
      template={template}
    />
  ))
);

const mapStateToProps = ({
  catalogues: { templates },
  datasets: { datasets },
}, ownProps) => {
  const { dataset, template } = resolveCatalogueTemplate(datasets, templates, ownProps, {
    activeDictionaryName: '',
    dictionaries: [],
    saveErrors: [],
  });
  const dictionary = findMatch(dataset.dictionaries, dataset.activeDictionaryName, 'name')
    || { fields: [], uuid: null };

  return (
    {
      dictionaryUUID: dictionary.uuid,
      fields: dictionary.fields,
      template,
      validationErrors: dataset.saveErrors,
    }
  );
};

export default connect(mapStateToProps)(DictionaryFieldTableRows);
